import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { UserSession } from './authentication.interfaces';

export const POST_LOGIN_PROCESSOR: InjectionToken<PostLoginProcessor> = new InjectionToken('POST_LOGIN_PROCESSOR');
export const LATE_LOGIN_PROCESSOR: InjectionToken<PostLoginProcessor> = new InjectionToken('LATE_LOGIN_PROCESSOR');

/**
 * Event that will be triggered AFTER successful login
 * Events will be executed in registration order
 */
export interface PostLoginProcessor {
	execute(userSession: UserSession): Observable<UserSession>;
}
